import { render } from "./GeneralFormInputs.vue?vue&type=template&id=a09210b6"
import script from "./GeneralFormInputs.vue?vue&type=script&lang=js"
export * from "./GeneralFormInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__